module.exports = __webpack_public_path__ + "img/func-detail-1.6cd330ee.png";